import Mock from "mockjs";
//查詢
Mock.mock(/\/api\/holder\/findByCondition/, "post", function(options){
    var data = options;
    console.log(JSON.stringify(data));
    return Mock.mock({
        "result": true,
        "message": "客戶資料查詢成功",
        "current_page": 1,
        "last_page": 1,
        "per_page": 30,
        "total_count": 2,
        "list": [
            {
                "id": 92,
                "name": "官庭麟",
                "eng_name": "",
                "birthday": "1992-08-11",
                "sex": "male",
                "city": "宜蘭縣",
                "township": "冬山鄉",
                "address": "三香路50號",
                "created_at": "2021-03-29T16:38:02.000000Z",
                "updated_at": "2021-03-29T16:38:02.000000Z",
                "level": "A",
                "phone": "",
                "connection_city": "",
                "connection_township": "",
                "connection_address": "",
                "deleted_at": null
            },
            {
                "id": 93,
                "name": "官庭麟/被保人-官雨青",
                "eng_name": "",
                "birthday": "1992-08-11",
                "sex": "male",
                "city": "宜蘭縣",
                "township": "冬山鄉",
                "address": "三香路50號",
                "created_at": "2021-03-29T16:40:03.000000Z",
                "updated_at": "2021-03-29T16:40:03.000000Z",
                "level": "A",
                "phone": "",
                "connection_city": "",
                "connection_township": "",
                "connection_address": "",
                "deleted_at": null
            }
        ]
    });
});


//put:更新
Mock.mock(/\/api\/holder/, "put", function(options){
    var data = options;
    console.log(data);
    return Mock.mock({
        status: 200,
        message: "mock update success",
        result: true,
        item: options.body
    });
})

//get:/api/holder/{id}
Mock.mock(/\/api\/holder/, "get", function(options) {
    //console.log(options);
    //如果沒有帶參數，就是抓全部
    var urlAry = options.url.split('/api/holder')
    //console.log(urlAry)
    if (urlAry[1].length > 1) {
      //get:/api/tutorials/${id}
      //如果是用return, 一定要回傳Mock.mock()
      return Mock.mock({
        "result": true,
        "message": "客戶資料查詢成功",
        "item": {
            "id": 92,
            "name": "官庭麟",
            "eng_name": "",
            "birthday": "1992-08-11",
            "sex": "male",
            "city": "宜蘭縣",
            "township": "冬山鄉",
            "address": "三香路50號",
            "created_at": "2021-03-29T16:38:02.000000Z",
            "updated_at": "2021-03-29T16:38:02.000000Z",
            "level": "",
            "phone": "",
            "connection_city": "",
            "connection_township": "",
            "connection_address": "",
            "deleted_at": null
        }
      });
    }
  });